import { render, staticRenderFns } from "./VueJsonEditor.vue?vue&type=template&id=e00f0d4c&scoped=true"
import script from "./VueJsonEditor.vue?vue&type=script&lang=js"
export * from "./VueJsonEditor.vue?vue&type=script&lang=js"
import style0 from "./VueJsonEditor.vue?vue&type=style&index=0&id=e00f0d4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e00f0d4c",
  null
  
)

export default component.exports